import { useEffect, useRef } from 'react';
import TopBar from './Topbar';
import Navbar from './Navbar';

const SiteHeader = () => {
  const ref = useRef(null);

  useEffect(() => {
    const measure = () => {
      if (ref.current) {
        const h = ref.current.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${h}px`);
      }
    };

    measure(); // run on mount

    const observer = new ResizeObserver(measure);
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Fixed header — always on top */}
      <div
        ref={ref}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 50,
          width: '100%',
        }}
      >
        <TopBar />
        <Navbar />
      </div>
      <div style={{ height: 'var(--header-height, 104px)' }} aria-hidden="true" />
    </>
  );
};

export default SiteHeader;